import { useState, useEffect } from "react";
import axios from "axios";
import { Shield } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = async (accepted) => {
    localStorage.setItem("cookie_consent", accepted ? "accepted" : "declined");
    setShow(false);
    try {
      await axios.post(`${API}/cookie-consent`, { consent: accepted, analytics: accepted, marketing: false });
    } catch { /* silent */ }
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-consent-banner" className="fixed bottom-0 left-0 right-0 z-40 p-4 md:p-6">
      <div className="max-w-4xl mx-auto glass-card rounded-sm p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Shield size={20} className="text-gold flex-shrink-0 mt-1 sm:mt-0" />
        <p className="text-white/60 text-sm font-body font-light flex-1 leading-relaxed">
          We use cookies to enhance your experience on our platform. By continuing, you agree to our{" "}
          <a href="/privacy" className="text-gold hover:text-gold-light underline">Privacy Policy</a>.
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button
            data-testid="cookie-decline-btn"
            onClick={() => handleConsent(false)}
            className="px-5 py-2 border border-white/20 text-white/70 text-sm font-body hover:border-white/40 transition-colors"
          >
            Decline
          </button>
          <button
            data-testid="cookie-accept-btn"
            onClick={() => handleConsent(true)}
            className="px-5 py-2 bg-gold text-black text-sm font-body font-medium hover:bg-gold-light transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
